import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./AdminHeader.css"; // Custom CSS for exact styling

const AdminHeader = () => {
  return (
    <Container fluid className="AdminHeader-container">
      <Row className="align-items-center AdminHeader-row">
        <Col lg={6} md={12} className="AdminHeader-image-container">
          <Image
            src="https://caas.athenahealth.com/sites/default/files/styles/webp_image_style/public/2024/10/BH_Workflow.webp?itok=1MZaC5Ab"
            alt="Behavioral Health EHR"
            className="AdminHeader-image"
            fluid
          />
        </Col>
        <Col lg={6} md={12} className="AdminHeader-text">
          <h6 className="AdminHeader-subtitle">Who we serve</h6>
          <h2 className="AdminHeader-title" style={{ color: "white" }}>
            Our expertise spans a broad continuum of providers including
          </h2>
          <p className="AdminHeader-description" style={{ color: "white" }}>
            Individual Physicians, Therapists, DME Suppliers, Ambulatory Surgery
            Centers, Ambulance Services, Acute Care Hospitals, CAH'S, Emergency
            Units, Urgent Care Centers, Radiology Centers, Hospice, Renal
            Dialysis Centers, FQHCs, and many more.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminHeader;
